// extracted by mini-css-extract-plugin
module.exports = {"wrap":"sk-z","articleImagesWrap":"tk-z","articleImage":"uk-z","singleImage":"vk-z"};